export default "__VITE_ASSET__BNVlq5sI__"